import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import { Paper, Typography } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { Button, ButtonGrey } from "../../style/Button";
import { ModalButton } from "../../style/ModalButton";
import TitlDollar from "../../assets/dollar.png";
import DollarGrey from "../../assets/dollargrey.png";
import { Image2 } from "../../style/Logo";
import "./select.css";
import medImg from "../../../src/assets/pharmcy/Copay Medizen.jpg";
import priImg from "../../../src/assets/pharmcy/Copay Primera.png";
function getModalStyle() {
  const top = 100;
  const left = 0;
  const right = 0;

  return {
    top: `${top}px`,
    left: `${left}px`,
    right: `${right}px`,
    margin: "0 auto",
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",
    width: 800,
    height: 700,
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #808080",
    borderRadius: 10,
    boxShadow: theme.shadows[5],
    padding: 0,
    overflow: "auto",
  },
  heading: {
    color: "#0389fb",
    fontSize: 15,
    fontFamily: "Arial",
    display: "flex",
    paddingBottom: 10,
    paddingLeft: 10,
  },
  sample: {
    backgroundColor: "#03b3fb",
    fontSize: 10,
    fontWeight: "Bold",
    paddingTop: 0,
    margin: 10,
    height: 20,
    padding: "0px",
    width: "180px",
    color: "white",
    borderRadius: 20,
    "&:hover": {
      backgroundColor: "#0389fb",
      color: "white",
    },
  },
  column: {
    marginLeft: 25,
    borderBottom: "0.5px solid #808080",
  },
  box1: {
    display: "block",
    float: "right",
    textAlign: "center",
    marginBottom: 10,
    height: 50,
    borderRight: "none",
    border: ".5px solid #808080",
    borderRadius: 0,
    width: 145,
    boxShadow: "none",
  },
  box2: {
    display: "block",
    float: "right",
    textAlign: "center",
    marginBottom: 10,
    height: 60,
    marginTop: -5,
    border: ".5px solid #808080",
    borderRadius: 0,
    width: 155,
    backgroundColor: "#666666",
    boxShadow: "none",
  },
  box3: {
    display: "block",
    float: "right",
    marginBottom: 10,
    height: 50,
    borderLeft: "none",
    border: ".5px solid #808080",
    borderRadius: 0,
    width: 165,
    boxShadow: "none",
  },

  Button1: {
    fontWeight: "600",
    fontFamily: "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
    textAlign: "center",
    backgroundColor: "#f2f2f2",
    borderRadius: 25,
    width: 120,
    textTransform: "none",
    Display: "Block",
    float: "right",
    height: 30,
    fontSize: 10,
    marginTop: -15,
    margin: 6,
    marginRight: 10,
    "&:hover": {
      backgroundColor: "#03b3fb",
      color: "white",
    },
  },
  Button2: {
    fontWeight: "600",
    fontFamily: "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
    textAlign: "center",
    backgroundColor: "#03b3fb",
    borderRadius: 25,
    color: "White",
    width: 150,
    Display: "Block",
    float: "right",
    textTransform: "none",
    height: 30,
    fontSize: 10,
    marginTop: -15,
    marginRight: 20,
    margin: 6,
    "&:hover": {
      backgroundColor: "#0389fb",
      color: "white",
    },
  },
}));

export default function Medication({ parentCallback }) {
  const classes = useStyles();
  const [modalStyle] = React.useState(getModalStyle);
  const [open, setOpen] = React.useState(false);

  const [rowsState] = React.useState([]);
  let [medarrayState] = React.useState([]);
  const [constructorHasRun, setConstructorHasRun] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseParentInfo = () => {
    setOpen(false);
    parentCallback("Popup");
  };

  const restoreRows = () => {
    if (constructorHasRun) return;
    let rowstring = window.sessionStorage.getItem("medarray");
    if (rowstring) {
      medarrayState = JSON.parse(rowstring);
    }
    if (medarrayState.length > 0) {
      medarrayState.forEach((element) => {
        createRows(element);
      });
    }
    setConstructorHasRun(true);
  };

  const createRows = (valuem) => {
    let discount;
    if (valuem.discount) {
      discount = (
        <React.Fragment>
          <Image2 src={TitlDollar} alt="logo" style={{marginTop:"0", marginLeft:"-40px"}} />{" "}
          <span style={{ fontWeight: 400, marginTop: "-4px", color: "green" }}>
            Coupon/Guide Available
          </span>
        </React.Fragment>
      );
    } else {
      discount = (
        <React.Fragment>
          <Image2 src={DollarGrey} alt="logo" style={{marginTop:"0", marginLeft:"-40px"}}  />{" "}
          <span style={{ fontWeight: 500, marginTop: "-4px", color: "grey" }}>
            NA
          </span>
        </React.Fragment>
      );
    }
    let imageValue;
    if (valuem.medicationName === "Medizen") {
      imageValue = <img src={medImg} style={{ width: "100%" }} />;
    } else if (valuem.medicationName === "Primera") {
      imageValue = <img src={priImg} style={{ width: "100%" }} />;
    }
    rowsState.push(
      <React.Fragment>
        <Grid
          container
          spacing={0}
          style={{
            borderBottom: ".5px solid #808080",
            margin: 25,
            marginTop: -20,
            paddingBottom: 15,
          }}
        >
          <Grid item md={4} xs={12}>
            <Typography
              style={{
                padding: 7,
                fontSize: 15.52,
                fontWeight: "600",
                paddingTop: 20,
              }}
            >
              Prescriptions Sent
              <br />
              <span
                style={{
                  fontWeight: 400,
                  marginTop: 5,
                  color: "#4678ED",
                }}
              >
                {valuem.medicationName}
              </span>
            </Typography>
          </Grid>
          <Grid item md={4} xs={12}>
            <Typography
              style={{
                padding: 7,
                fontSize: 15.52,
                fontWeight: "600",
                paddingTop: 20,
              }}
            >
              Status
              <br />
              <span style={{ fontWeight: 400, marginTop: 5, color: "green" }}>
                Sent Successfully
              </span>
            </Typography>
          </Grid>
          <Grid item md={4} xs={12}>
            <Typography
              style={{
                padding: "20px 0 7px 37px",
                fontSize: 15.52,
                fontWeight: "600",
              }}
            >
              Coupon
              <br />
              {discount}
            </Typography>
          </Grid>
          <Grid container
            spacing={0}
            style={{ marginTop:'20px', marginBottom:"20px"}}>
            <Grid item md={2}>
            </Grid>
            <Grid item md={10}>
              <Typography>{imageValue}</Typography>
            </Grid>

          </Grid>
        </Grid>
      </React.Fragment>
    );
  };

  restoreRows();

  const body = (
    <div style={modalStyle} className={`${classes.paper} responsivePopUp`}>
      <Grid container spacing={0} style={{paddingBottom:"30px"}}>
        <Grid
          item
          xs={12}
          style={{
            borderBottom: ".5px solid #d8d6d6",
            paddingTop: 20,
            paddingLeft: 36,
          }}
        >
          <Typography
            style={{
              color: "#4678ED",
              fontWeight: 600,
              marginTop: "0px",
              fontSize: "19.4px",
              marginBottom: "12px",
            }}
          >
            Prescription Confirmation{" "}
            <span
              style={{
                fontWeight: "bolder",
                color: "black",
                paddingRight: "30px",
              }}
            ></span>
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          container
          spacing={0}
          style={{
            borderBottom: ".5px solid #808080",
            margin: 25,
            marginTop: 0,
            marginBottom: 15,
            display:"block"
          }}
        >
          <Typography style={{ padding: 10, fontSize: 19.4, fontWeight: 600 }}>
            Medication samples and coupons delivered right to your office.{" "}
            <span style={{ color: "#0389fb" }}>Free. Easy. Fast.</span>
          </Typography>

          <Typography
            style={{
              fontSize: 12.11,
              fontWeight: 400,
              paddingLeft: 10,
              marginTop: -10,
            }}
          >
            Request multiple products from a variety of suppliers, prescription
            saving cards, and get access to vouchers.
            <br /> Want to see the samples available to you? Find out now!
          </Typography>
          <Button
            className={classes.sample}
            style={{
              backgroundImage:
                "linear-gradient(315deg, #7f7f7f 0%, #9e9e9e 74%)",
              color: "white",
              fontSize: 12.11,
              padding: "5px 20px",
              height: "auto",
              width: "auto"
            }}
          >
            Learn more at sample center
          </Button>
        </Grid>
        <Grid
          container
          spacing={0}
          style={{
            borderBottom: ".5px solid #808080",
            margin: 25,
            marginTop: -10,
            marginBottom: 15,
          }}
        >
          <Grid item  md={4} xs={12}>
            <Typography
              style={{
                padding: 10,
                fontSize: 15.52,
                fontWeight: "600",
                paddingTopt: 20,
              }}
            >
              Pick Up Location
              <br />
              <p style={{ fontWeight: 15.52, marginTop: "9px" }}>
                Phone: 703-205-7034
                <br />
                Fax: 703-205-7035
              </p>
            </Typography>
          </Grid>
          <Grid item md={7} xs={12}>
            <Typography
              style={{
                padding: 10,
                fontSize: 15.52,
                fontWeight: "600",
                paddingLeft: 20,
                marginBottom: "12px"
              }}
            >
              VA Pharmacy 10.6MU
              <br />
              <p style={{ fontWeight: 15.52, marginTop: "9px" }}>
                7723 Jefferson Davis Highway
                <br />
                Arlington, VA 22201
              </p>
            </Typography>
          </Grid>
        </Grid>
       
        {rowsState.map((name) => name)}
        <br />
        <Grid item xs={12} className="flex-wrap marginTabs margBetter maxWidthButton fourButtons">
          <Button
            className={classes.Button2}
            onClick={handleCloseParentInfo}
          >
            Send To Pharmacy
          </Button>
          <Button
            className={classes.Button1}
          >
            Print
          </Button>
          <Button
            className={classes.Button1}
          >
            Text
          </Button>
          <Button
            className={classes.Button1}
          >
            Email
          </Button>
        </Grid>
      </Grid>
    </div>
  );

  return (
    <div>
      <Button
        height="fit-content"
        borderRadius="20px"
        onClick={handleOpen}
        style={{
          padding:"8px 25px",
          marginTop: 0,
          fontSize: "16px",
          marginLeft: "18px",
          backgroundImage: "none",
          backgroundColor: "#D0D2D3",
          color: "#606060",
          fontWeight: 600,
          fontFamily: "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
          textAlign: "center",
        }}
      >
        Process Medications
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        {body}
      </Modal>
      <br />
    </div>
  );
}
